/**
 * 서버 실행 시, 자동으로 생성된 api path와 method 모음 파일입니다.
 * 커밋에 누락되지 않도록 꼭 추가해주세요.
 * pnpm run prettier:fix를 통해 lint를 맞춰주세요.
 */
import type {Method} from 'axios'

interface ApiInfo {
    path: string
    method: Method
    queryKey: string[]
}

export const MYASSET_APIS: Record<string, ApiInfo> = {
    POST_NELO_LOGGING: {path: '/nelo/logging', method: 'POST', queryKey: []},
    GET_BANK_DEPOSIT_ACCOUNT: {
        path: '/bank/deposit/account',
        method: 'GET',
        queryKey: ['GET', 'api', 'bank', 'deposit', 'account'],
    },
    GET_BANK_DEPOSIT_STATEMENTS: {
        path: '/bank/deposit/statements',
        method: 'GET',
        queryKey: ['GET', 'api', 'bank', 'deposit', 'statements'],
    },
    GET_BANK_FUND_ACCOUNT: {
        path: '/bank/fund/account',
        method: 'GET',
        queryKey: ['GET', 'api', 'bank', 'fund', 'account'],
    },
    GET_BANK_FUND_STATEMENTS: {
        path: '/bank/fund/statements',
        method: 'GET',
        queryKey: ['GET', 'api', 'bank', 'fund', 'statements'],
    },
    GET_BANK_FUND_STATEMENT: {
        path: '/bank/fund/statement',
        method: 'GET',
        queryKey: ['GET', 'api', 'bank', 'fund', 'statement'],
    },
    GET_BANK_ISA_ACCOUNT: {
        path: '/bank/isa/account',
        method: 'GET',
        queryKey: ['GET', 'api', 'bank', 'isa', 'account'],
    },
    GET_BANK_ISA_PRODUCTS: {
        path: '/bank/isa/products',
        method: 'GET',
        queryKey: ['GET', 'api', 'bank', 'isa', 'products'],
    },
    GET_BANK_ISA_STATEMENTS: {
        path: '/bank/isa/statements',
        method: 'GET',
        queryKey: ['GET', 'api', 'bank', 'isa', 'statements'],
    },
    GET_BANK_LIST: {path: '/bank/list', method: 'GET', queryKey: ['GET', 'api', 'bank', 'list']},
    GET_BANK_HASBANKLIST: {path: '/bank/hasBankList', method: 'GET', queryKey: ['GET', 'api', 'bank', 'hasBankList']},
    GET_BANK_ACCOUNT_SIMPLEPAY: {
        path: '/bank/account/simplepay',
        method: 'GET',
        queryKey: ['GET', 'api', 'bank', 'account', 'simplepay'],
    },
    'GET_BANK_ACCOUNT_[ASSETID]_INTEREST': {
        path: '/bank/account/:assetId/interest',
        method: 'GET',
        queryKey: ['GET', 'api', 'bank', 'account', ':assetId', 'interest'],
    },
    GET_BANK_ACCOUNT_INTERESTS: {
        path: '/bank/account/interests',
        method: 'GET',
        queryKey: ['GET', 'api', 'bank', 'account', 'interests'],
    },
    GET_BANK_ACCOUNT_SCHEDULED_ACCOUNTS: {
        path: '/bank/account/scheduled-accounts',
        method: 'GET',
        queryKey: ['GET', 'api', 'bank', 'account', 'scheduled-accounts'],
    },
    GET_CARD_COMMON_UNI_CARDS: {
        path: '/card/common/uni-cards',
        method: 'GET',
        queryKey: ['GET', 'api', 'card', 'common', 'uni-cards'],
    },
    POST_CARD_APPROVALS_GOALS: {path: '/card/approvals/goals', method: 'POST', queryKey: []},
    DELETE_CARD_APPROVALS_GOALS: {path: '/card/approvals/goals', method: 'DELETE', queryKey: []},
    GET_CARD_APPROVALS_HASCARDLIST: {
        path: '/card/approvals/hasCardList',
        method: 'GET',
        queryKey: ['GET', 'api', 'card', 'approvals', 'hasCardList'],
    },
    GET_CARD_APPROVALS_SUMMARY: {
        path: '/card/approvals/summary',
        method: 'GET',
        queryKey: ['GET', 'api', 'card', 'approvals', 'summary'],
    },
    'GET_CARD_APPROVALS_:APPROVALID': {
        path: '/card/approvals/:approvalId',
        method: 'GET',
        queryKey: ['GET', 'api', 'card', 'approvals', ':approvalId'],
    },
    GET_CARD_APPROVALS: {path: '/card/approvals', method: 'GET', queryKey: ['GET', 'api', 'card', 'approvals']},
    GET_CARD_REVOLVINGS: {path: '/card/revolvings', method: 'GET', queryKey: ['GET', 'api', 'card', 'revolvings']},
    'GET_CARD_PAYMENTS_:PAYMENTID': {
        path: '/card/payments/:paymentId',
        method: 'GET',
        queryKey: ['GET', 'api', 'card', 'payments', ':paymentId'],
    },
    GET_CARD_BILLS_UNI_BILLS: {
        path: '/card/bills/uni-bills',
        method: 'GET',
        queryKey: ['GET', 'api', 'card', 'bills', 'uni-bills'],
    },
    'GET_CARD_BILLS_:BILLID': {
        path: '/card/bills/:billId',
        method: 'GET',
        queryKey: ['GET', 'api', 'card', 'bills', ':billId'],
    },
    GET_CARD_POINTS: {path: '/card/points', method: 'GET', queryKey: ['GET', 'api', 'card', 'points']},
    GET_CARD_SIMPLEPAY_CARDS: {
        path: '/card/simplepay-cards',
        method: 'GET',
        queryKey: ['GET', 'api', 'card', 'simplepay-cards'],
    },
    GET_CARD_PREPAID_CARDS_CURRENT: {
        path: '/card/prepaid-cards/current',
        method: 'GET',
        queryKey: ['GET', 'api', 'card', 'prepaid-cards', 'current'],
    },
    'GET_CARD_CARDS_:ASSETID': {
        path: '/card/cards/:assetId',
        method: 'GET',
        queryKey: ['GET', 'api', 'card', 'cards', ':assetId'],
    },
    'GET_INVEST_ACCOUNTS_:ASSETID': {
        path: '/invest/accounts/:assetId',
        method: 'GET',
        queryKey: ['GET', 'api', 'invest', 'accounts', ':assetId'],
    },
    GET_CONNECT_EXPIRES: {path: '/connect/expires', method: 'GET', queryKey: ['GET', 'api', 'connect', 'expires']},
    GET_CONNECT_ORGANIZATIONS: {
        path: '/connect/organizations',
        method: 'GET',
        queryKey: ['GET', 'api', 'connect', 'organizations'],
    },
    GET_MYDATA_REGISTRATION: {
        path: '/mydata/registration',
        method: 'GET',
        queryKey: ['GET', 'api', 'mydata', 'registration'],
    },
    GET_MYDATA_ORGANIZATIONS: {
        path: '/mydata/organizations',
        method: 'GET',
        queryKey: ['GET', 'api', 'mydata', 'organizations'],
    },
    GET_MYDATA_ORGANIZATION: {
        path: '/mydata/organization',
        method: 'GET',
        queryKey: ['GET', 'api', 'mydata', 'organization'],
    },
    GET_MYDATA_AGREEMENT: {path: '/mydata/agreement', method: 'GET', queryKey: ['GET', 'api', 'mydata', 'agreement']},
    GET_REWARD_CANDIDATES: {
        path: '/reward/candidates',
        method: 'GET',
        queryKey: ['GET', 'api', 'reward', 'candidates'],
    },
    POST_UPDATER_ASYNC: {path: '/updater/async', method: 'POST', queryKey: []},
    GET_SESSION_IO_CONNECTION: {
        path: '/session-io/connection',
        method: 'GET',
        queryKey: ['GET', 'api', 'session-io', 'connection'],
    },
    PATCH_BADGE_ACTIVITIES: {path: '/badge/activities', method: 'PATCH', queryKey: []},
    GET_SAVING_PRIMEINTEREST: {
        path: '/saving/primeInterest',
        method: 'GET',
        queryKey: ['GET', 'api', 'saving', 'primeInterest'],
    },
    GET_EFIN_POINT: {path: '/efin/point', method: 'GET', queryKey: ['GET', 'api', 'efin', 'point']},
    GET_EFIN_PAYMONEY: {path: '/efin/paymoney', method: 'GET', queryKey: ['GET', 'api', 'efin', 'paymoney']},
    GET_EFIN_HASEFINLIST: {path: '/efin/hasEfinList', method: 'GET', queryKey: ['GET', 'api', 'efin', 'hasEfinList']},
    GET_EFIN_ASSETS: {path: '/efin/assets', method: 'GET', queryKey: ['GET', 'api', 'efin', 'assets']},
    GET_EFIN_STATEMENTS: {path: '/efin/statements', method: 'GET', queryKey: ['GET', 'api', 'efin', 'statements']},
    GET_EFIN_PREPAID_BALANCES: {
        path: '/efin/prepaid/balances',
        method: 'GET',
        queryKey: ['GET', 'api', 'efin', 'prepaid', 'balances'],
    },
    GET_EFIN_PREPAID_CHARGE: {
        path: '/efin/prepaid/charge',
        method: 'GET',
        queryKey: ['GET', 'api', 'efin', 'prepaid', 'charge'],
    },
    GET_EFIN_PREPAID_STATEMENT: {
        path: '/efin/prepaid/statement',
        method: 'GET',
        queryKey: ['GET', 'api', 'efin', 'prepaid', 'statement'],
    },
    GET_EFIN_PAID_STATEMENT: {
        path: '/efin/paid/statement',
        method: 'GET',
        queryKey: ['GET', 'api', 'efin', 'paid', 'statement'],
    },
    GET_INSURANCE_COVERAGES_UNI_COVERAGES: {
        path: '/insurance/coverages/uni/coverages',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'coverages', 'uni', 'coverages'],
    },
    GET_INSURANCE_COVERAGES_LIST: {
        path: '/insurance/coverages/list',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'coverages', 'list'],
    },
    GET_INSURANCE_COVERAGES_PEER: {
        path: '/insurance/coverages/peer',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'coverages', 'peer'],
    },
    GET_INSURANCE_MY_DETAIL_GENERAL: {
        path: '/insurance/my/detail/general',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'my', 'detail', 'general'],
    },
    GET_INSURANCE_MY_STATEMENTS_GENERAL: {
        path: '/insurance/my/statements/general',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'my', 'statements', 'general'],
    },
    GET_INSURANCE_MY_NOTICE: {
        path: '/insurance/my/notice',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'my', 'notice'],
    },
    GET_INSURANCE_MY_NOTICES: {
        path: '/insurance/my/notices',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'my', 'notices'],
    },
    GET_INSURANCE_MY_DETAIL_CAR: {
        path: '/insurance/my/detail/car',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'my', 'detail', 'car'],
    },
    GET_INSURANCE_MY_STATEMENTS_CAR: {
        path: '/insurance/my/statements/car',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'my', 'statements', 'car'],
    },
    GET_INSURANCE_MY_CONTRACTS: {
        path: '/insurance/my/contracts',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'my', 'contracts'],
    },
    GET_INSURANCE_MY_DETAIL_GUARANTEE: {
        path: '/insurance/my/detail/guarantee',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'my', 'detail', 'guarantee'],
    },
    GET_INSURANCE_MY_STATEMENTS_GUARANTEE: {
        path: '/insurance/my/statements/guarantee',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'my', 'statements', 'guarantee'],
    },
    GET_INSURANCE_MY_RCODE: {
        path: '/insurance/my/rCode',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'my', 'rCode'],
    },
    PUT_INSURANCE_HOME_SAVERCODE: {path: '/insurance/home/saveRCode', method: 'PUT', queryKey: []},
    GET_INSURANCE_HOME_UNI_STATEMENTS: {
        path: '/insurance/home/uni/statements',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'home', 'uni', 'statements'],
    },
    GET_INSURANCE_DIAGNOSIS_CRITERIA: {
        path: '/insurance/diagnosis/criteria',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'diagnosis', 'criteria'],
    },
    POST_INSURANCE_DIAGNOSIS_CRITERIA: {path: '/insurance/diagnosis/criteria', method: 'POST', queryKey: []},
    GET_INSURANCE_DIAGNOSIS_TAXRETURN: {
        path: '/insurance/diagnosis/taxReturn',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'diagnosis', 'taxReturn'],
    },
    GET_INSURANCE_DIAGNOSIS_PREMIUM: {
        path: '/insurance/diagnosis/premium',
        method: 'GET',
        queryKey: ['GET', 'api', 'insurance', 'diagnosis', 'premium'],
    },
    GET_INSURANCE_UNI: {path: '/insurance/uni', method: 'GET', queryKey: ['GET', 'api', 'insurance', 'uni']},
    GET_MEMBER_INFO: {path: '/member/info', method: 'GET', queryKey: ['GET', 'api', 'member', 'info']},
    GET_MEMBER_BIRTHDAY: {path: '/member/birthday', method: 'GET', queryKey: ['GET', 'api', 'member', 'birthday']},
    GET_MEMBER_MEMBERSHIPJOINED: {
        path: '/member/membershipJoined',
        method: 'GET',
        queryKey: ['GET', 'api', 'member', 'membershipJoined'],
    },
    GET_REMIT_ORG: {path: '/remit/org', method: 'GET', queryKey: ['GET', 'api', 'remit', 'org']},
    POST_REMIT_RKEY: {path: '/remit/rKey', method: 'POST', queryKey: []},
    GET_INSURANCE_RESOURCE_PEER_AVERAGE_BENEFIT_AMT: {
        path: '/insurance/resource/peer-average-benefit-amt',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'resource', 'peer-average-benefit-amt'],
    },
    GET_INSURANCE_RESOURCE_PEER_AVERAGE_BENEFIT_RANK: {
        path: '/insurance/resource/peer-average-benefit-rank',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'resource', 'peer-average-benefit-rank'],
    },
    GET_INSURANCE_RESOURCE_PEER_AVERAGE_PREMIUM_RANK: {
        path: '/insurance/resource/peer-average-premium-rank',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'resource', 'peer-average-premium-rank'],
    },
    GET_INSURANCE_RESOURCE_AVG_PREMIUM_BY_TABNAME: {
        path: '/insurance/resource/avg-premium-by-tabName',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'resource', 'avg-premium-by-tabName'],
    },
    GET_INSURANCE_RESOURCE_ORGRANKING: {
        path: '/insurance/resource/orgRanking',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'resource', 'orgRanking'],
    },
    GET_INSURANCE_RESOURCE_COVERAGERANKING: {
        path: '/insurance/resource/coverageRanking',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'resource', 'coverageRanking'],
    },
    GET_INSURANCE_RESOURCE_INCOME_QUANTILES: {
        path: '/insurance/resource/income-quantiles',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'resource', 'income-quantiles'],
    },
    GET_INSURANCE_RESOURCE_PEER_AVERAGE_PREMIUM: {
        path: '/insurance/resource/peer-average-premium',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'resource', 'peer-average-premium'],
    },
    GET_INSURANCE_RESOURCE_PEER_AVERAGE_PREMIUM_NOLOGIN: {
        path: '/insurance/resource/peer-average-premium-nologin',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'resource', 'peer-average-premium-nologin'],
    },
    GET_INSURANCE_RESOURCE_PREMIUM_COMPARISON_BY_TYPE: {
        path: '/insurance/resource/premium-comparison-by-type',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'resource', 'premium-comparison-by-type'],
    },
    GET_INSURANCE_CONTENTS: {
        path: '/insurance/contents',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'contents'],
    },
    GET_INSURANCE_CONTENTS_COVERAGES: {
        path: '/insurance/contents/coverages',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'contents', 'coverages'],
    },
    GET_INSURANCE_CONTENTS_SUMMARY: {
        path: '/insurance/contents/summary',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'contents', 'summary'],
    },
    GET_INSURANCE_CONTENTS_DETAIL: {
        path: '/insurance/contents/detail',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'contents', 'detail'],
    },
    GET_INSURANCE_CONTENTS_SUGGESTKEYWORDS: {
        path: '/insurance/contents/suggestKeywords',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'contents', 'suggestKeywords'],
    },
    GET_INSURANCE_REGIONS: {
        path: '/insurance/regions',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'regions'],
    },
    GET_INSURANCE_REGION: {
        path: '/insurance/region',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'region'],
    },
    GET_INSURANCE_FREE_RCODE: {
        path: '/insurance/free/rcode',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'free', 'rcode'],
    },
    GET_INSURANCE_FREE_DETAIL: {
        path: '/insurance/free/detail',
        method: 'GET',
        queryKey: ['GET', 'ext-api', 'insurance', 'free', 'detail'],
    },
    GET_INSURANCE_CONTENTS_RECOMMENDED: {
        path: '/insurance/contents/recommended',
        method: 'GET',
        queryKey: ['GET', 'auth-api', 'insurance', 'contents', 'recommended'],
    },
    GET_INSURANCE_CONTENTS_BANNER: {
        path: '/insurance/contents/banner',
        method: 'GET',
        queryKey: ['GET', 'auth-api', 'insurance', 'contents', 'banner'],
    },
    GET_INSURANCE_MYASSET: {
        path: '/insurance/myasset',
        method: 'GET',
        queryKey: ['GET', 'auth-api', 'insurance', 'myasset'],
    },
}

export function getQueryKey(apiInfo: ApiInfo, customKeys: string[] = []) {
    const {queryKey: originalKey} = apiInfo
    if (!originalKey) {
        throw new Error('지원하지 않는 key 입니다.')
    }
    return [...originalKey, ...customKeys]
}

export * from '$share/types/account'
export * from '$share/types/asset'
export * from '$share/types/bank/account'
export * from '$share/types/bank/api'
export * from '$share/types/bank/deposit'
export * from '$share/types/bank/fund'
export * from '$share/types/bank/interest'
export * from '$share/types/bank/isa'
export * from '$share/types/benefitPoint'
export * from '$share/types/card/approval'
export * from '$share/types/card/bills'
export * from '$share/types/card/common'
export * from '$share/types/card/payments'
export * from '$share/types/card/point'
export * from '$share/types/card/revolvings'
export * from '$share/types/card'
export * from '$share/types/common'
export * from '$share/types/connect/api'
export * from '$share/types/connect/common'
export * from '$share/types/connect/expire'
export * from '$share/types/connect/organization'
export * from '$share/types/efin/api'
export * from '$share/types/efin/asset'
export * from '$share/types/efin/balances'
export * from '$share/types/efin/statements'
export * from '$share/types/insurance/car'
export * from '$share/types/insurance/contents'
export * from '$share/types/insurance/diagnosis'
export * from '$share/types/insurance/free'
export * from '$share/types/insurance/general'
export * from '$share/types/insurance/guaranteed'
export * from '$share/types/insurance/home'
export * from '$share/types/insurance'
export * from '$share/types/insurance/myasset'
export * from '$share/types/insurance/resource'
export * from '$share/types/invest/account'
export * from '$share/types/loan'
export * from '$share/types/myCar'
export * from '$share/types/nelo'
export * from '$share/types/organization'
export * from '$share/types/paymoney'
export * from '$share/types/pension'
export * from '$share/types/prepaid'
export * from '$share/types/query'
export * from '$share/types/react-query'
export * from '$share/types/remit'
export * from '$share/types/reward'
export * from '$share/types/savings/api'
export * from '$share/types/savings/product'
export * from '$share/types/session-io'
export * from '$share/types/simple'
export * from '$share/types/updater'
